import { render, staticRenderFns } from "./BasicMentionList.vue?vue&type=template&id=3009f1bc&scoped=true&"
import script from "./BasicMentionList.vue?vue&type=script&lang=js&"
export * from "./BasicMentionList.vue?vue&type=script&lang=js&"
import style0 from "./BasicMentionList.vue?vue&type=style&index=0&id=3009f1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3009f1bc",
  null
  
)

export default component.exports